<template>
  <div class="d-flex flex-wrap align-center justify-center" style="gap: 4px">
    <Typography variant="subtitle-2">{{
      $t("aggregateLearningLeaderboard.sort.label")
    }}</Typography>
    <v-btn-toggle
      :value="value"
      @change="handleChange"
      mandatory
      rounded
      dense
      :disabled="disabled"
      background-color="#f6f5f6"
    >
      <v-btn
        value="learning"
        text
        :color="isLearningActive ? accentColor : 'mediumGrey'"
        :disabled="disabled"
        class="px-3"
        :small="isMobile"
        data-testid="sort-learning-btn"
      >
        <Icon
          icon="mdi-school"
          small
          :color="isLearningActive ? accentColor : 'mediumGrey'"
          class="mr-1"
        />
        {{ $t("aggregateLearningLeaderboard.sort.learning") }}
      </v-btn>
      <v-btn
        value="badges"
        text
        :color="isBadgesActive ? accentColor : 'mediumGrey'"
        :disabled="disabled"
        class="px-3"
        :small="isMobile"
        data-testid="sort-badges-btn"
      >
        <Icon
          icon="mdi-medal-outline"
          small
          :color="isBadgesActive ? accentColor : 'mediumGrey'"
          class="mr-1"
        />
        {{ $t("aggregateLearningLeaderboard.sort.badges") }}
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Icon from "@/components/generic/Icon.vue";

import isMobileMixin from "@/mixins/isMobile";

export default {
  name: "AggregateLearningLeaderboardSort",
  components: { Typography, Icon },
  mixins: [isMobileMixin],
  props: {
    value: {
      type: String,
      default: "learning",
      validator: (v) => ["learning", "badges"].includes(v),
    },
    accentColor: {
      type: String,
      default: "#077DAF",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isLearningActive() {
      return this.value === "learning";
    },
    isBadgesActive() {
      return this.value === "badges";
    },
  },
  methods: {
    handleChange(newValue) {
      if (newValue && newValue !== this.value) {
        this.$emit("input", newValue);
      }
    },
  },
};
</script>
